
export const setLocalhostCookie = (name: string, value: string, days = 365) => {
    const expires = new Date()
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; domain=localhost; expires=${expires.toUTCString()}`
}

export const clearLocalhostCookie = (name: string) => {
    document.cookie = `${encodeURIComponent(name)}=; path=/; domain=localhost; max-age=0`
}
